module.exports = __webpack_public_path__ + "img/@contact_bottom_m.6c8a11ea.jpg";